import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { formatError, logError } from '../services/logging'
import { API_URL } from '../config/api'
import '../styles/portfolio.css'
import '../styles/home.css'

const ArtDetail = () => {
    const [currentArt, setCurrentArt] = useState(null)
    const { art_id } = useParams()

    useEffect(() => {
        const fetchArt = async () => {
            try {
                const resp = await fetch(`${API_URL}/api/artworks/${art_id}`, {
                    method: "GET",
                    credentials: "include"
                })
                const data = await resp.json()
                if (resp.ok) {
                    setCurrentArt(data)
                } else {
                    logError(data)
                    toast.error(data.message || "Failed to fetch artwork.")
                }
            } catch (error) {
                logError(formatError(error))
                toast.error("An unexpected error occurred. Please try again.")
            }
        }
        fetchArt()
    }, [art_id])

    const mappedReflections = currentArt?.prompt?.reflection?.map(ref => (
        <li key={ref}>{ref}</li>
    ))

  return (
    <div className='container'>
        {!currentArt ? (
            <section>
                <p>Loading...</p>
            </section>
        ) : (
            <section className='home-section'>
                <aside className='img-wrapper'>
                    <img 
                        src={currentArt.image_url} 
                        alt={currentArt.title || `Artwork ${currentArt.id}`} 
                    />
                </aside>
                <article>
                    <h2>{currentArt?.title || ""}</h2>
                    <h3>{currentArt.prompt.title}</h3>
                    <p>{currentArt.prompt.body}</p>
                    <h3>Reflection questions</h3>
                    <p>Take a few moments to consider the following questions. You can think through them or write down your responses if that feels helpful. There are no right or wrong answers — this is your space to reflect.</p>
                    <ul>
                        {mappedReflections}
                    </ul>
                </article>
            </section>
        )}
    </div>
  )
}

export default ArtDetail